export const getClassConditionalAppend = (extraClassName) => extraClassName ? ` ${extraClassName}` : "";
